import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/shared/components/ui/card";
import { Server, ArrowDown, ArrowUp } from "lucide-react";
import { useLanguage } from "@/shared/components/shared/LanguageContext";

export default function NetworkTraffic({ servers, translateServerName }) {
  const { t } = useLanguage();

  const formatRate = (value) => {
    if (value === null || value === undefined || value === "") return t("na");
    const n = Number(value);
    if (!Number.isFinite(n)) return t("na");
    return `${n.toFixed(2)} MB/s`;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("networkTraffic")}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {servers.map((server) => {
            const isEnabled = Boolean(server?.isDataReal);
            return (
              <div
                key={server.id}
                className={`flex flex-col sm:flex-row sm:items-center gap-4 p-4 rounded-xl transition-all ${
                  isEnabled ? "bg-slate-50" : "bg-slate-100 opacity-50 cursor-not-allowed"
                }`}
              >
                {/* Server Icon */}
                <div
                  className={`w-10 h-10 rounded-lg flex items-center justify-center shadow-sm ${
                    isEnabled ? "bg-white" : "bg-slate-200"
                  }`}
                >
                  <Server className={`h-5 w-5 ${isEnabled ? "text-slate-600" : "text-slate-400"}`} />
                </div>

                {/* Server Info */}
                <div className="flex-1 min-w-0 w-full">
                  <p className={`font-medium ${isEnabled ? "text-slate-900" : "text-slate-500"}`}>
                    {translateServerName(server.name)}
                    {!isEnabled && (
                      <span className="ml-2 text-xs text-slate-400">({t("disabled")})</span>
                    )}
                  </p>
                  <p className={`text-xs ${isEnabled ? "text-slate-500" : "text-slate-400"}`}>
                    {server.ip || t("na")}
                  </p>
                </div>

                {/* Network Stats */}
                <div className="grid grid-cols-2 gap-4 w-full sm:w-auto sm:flex sm:items-center sm:gap-6">
                  {/* Inbound Traffic */}
                  <div className="text-right">
                    <div className={`flex items-center gap-1 ${isEnabled ? "text-emerald-600" : "text-slate-400"}`}>
                      <ArrowDown className="h-3 w-3" />
                      <span className="font-medium">
                        {isEnabled ? formatRate(server?.network?.in) : t("na")}
                      </span>
                    </div>
                    <p className={`text-xs ${isEnabled ? "text-slate-500" : "text-slate-400"}`}>
                      {t("inbound")}
                    </p>
                  </div>

                  {/* Outbound Traffic */}
                  <div className="text-right">
                    <div className={`flex items-center gap-1 ${isEnabled ? "text-blue-600" : "text-slate-400"}`}>
                      <ArrowUp className="h-3 w-3" />
                      <span className="font-medium">
                        {isEnabled ? formatRate(server?.network?.out) : t("na")}
                      </span>
                    </div>
                    <p className={`text-xs ${isEnabled ? "text-slate-500" : "text-slate-400"}`}>
                      {t("outbound")}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
